import React, { Fragment } from 'react'
import { Row, Col, Input, Button } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck, faTrashAlt, faTimes } from '@fortawesome/free-solid-svg-icons'
import ConfirmButton from '../Modal/ConfirmButton';
import 'bootstrap/dist/css/bootstrap.css';


class ClientSecurities extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            editSecurity: {},
            newSecurity: {}
        };

        this.blankSecurity = {
            id: 0,
            type: '',
            symbol: '',
            assetClass: '',
            securityType: '',
            symbolTicker: '',
            cusip: '',
            notes: '',
            complete: ''
        }

    }

    onChange = (e, type) => {
        this.props.log('ClientSecurities.js/onChange (e, type)', e, type);
        e.persist();
        let thisSecurity = (type === 'edit') ? this.state.editSecurity : this.state.newSecurity;
        switch (e.target.name) {
            case "complete":
                thisSecurity[e.target.name] = !thisSecurity[e.target.name];
                break;
            default:
                thisSecurity[e.target.name] = e.target.value;
        }
        this.setState(() => {
            return (type === 'edit') ? { editSecurity: thisSecurity } : { newSecurity: thisSecurity };
        });
    }

    onEdit = (id) => {
        this.props.log('ClientSecurities.js/onEdit (id)', id);
        const security = [...this.props.report.securities].filter(item => item.id === id)[0];
        this.setState(() => {
            return {
                editSecurity: security
            }
        })
    }

    onDelete = (id) => {
        this.props.log('ClientSecurities.js/onDelete (id)', id);
        fetch('/api/clientSecurities/' + id, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken
            }
        })
            .then(results => results.json())
            .then(results => {
                if (results.success) {
                    this.setState({
                        editSecurity: { ...this.blankSecurity },
                    }, () => this.props.getClientReports());
                    this.props.addToast('Client security deleted successfully.', 5, 'success')
                } else {
                    this.props.addToast('Unable to delete client security.', 5, 'danger')
                }
            })
            .catch(() => {
                this.props.addToast('An error has occurred.', 5, 'danger');
            })
    }

    handleCancel = () => {
        this.props.log('ClientSecurities.js/handleCancel');
        this.setState({
            editSecurity: { ...this.blankSecurity },
        })
    }

    handleEdit = () => {
        this.props.log('ClientSecurities.js/handleEdit');
        fetch('/api/clientSecurities/' + this.state.editSecurity.id, {
            method: 'PUT',
            body: JSON.stringify({ ...this.state.editSecurity, clientReportId: this.props.selectedClientReportId }),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken
            }
        })
            .then(results => results.json())
            .then(results => {
                if (results.success) {
                    this.props.addToast('Client security updated successfully.', 5, 'success')
                    this.setState({
                        editSecurity: { ...this.blankSecurity }
                    }, () => this.props.getClientReports());
                } else {
                    this.props.addToast('Unable to update client security.', 5, 'danger')
                }
            })
            .catch(() => {
                this.props.addToast('An error has occurred.', 5, 'danger');
            })
    }

    handleAdd = (e) => {
        this.props.log('ClientSecurities.js/handleAdd (name, value, e)', e.target.name, e.target.value, e);
        fetch('/api/clientSecurities/', {
            method: 'POST',
            body: JSON.stringify({ ...this.state.newSecurity, clientReportId: this.props.selectedClientReportId }),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken
            }
        })
            .then(results => results.json())
            .then(results => {
                if (parseInt(results.data) > 0) {
                    this.setState({
                        newSecurity: { ...this.blankSecurity }
                    }, () => {
                        this.props.getClientReports();
                        this.props.addToast('Client security added successfully.', 5, 'success')
                    });
                } else {
                    this.props.addToast('Unable to add client security.', 5, 'danger')
                }
            })
            .catch(() => {
                this.props.addToast('An error has occurred.', 5, 'danger');
            })
    }

    standardRow = (security) => {
        this.props.info('ClientSecurities.js/standardRow (security)', security);
        return (
            <tr className='pointer' onClick={() => this.onEdit(security.id)}>
                <td>{security.type}</td>
                <td>{security.symbol}</td>
                <td>{security.assetClass}</td>
                <td>{security.securityType}</td>
                <td>{security.symbolTicker}</td>
                <td>{security.cusip}</td>
                <td>{security.notes}</td>
                <td>{security.complete ? 'Yes' : 'No'}</td>
                <td></td>
            </tr>
        )
    }

    editRow = (security) => {
        this.props.log('ClientSecurities.js/editRow (security)', security);
        return (
            <tr>
                <td>{this.state.editSecurity.type}</td>
                <td>{this.state.editSecurity.symbol}</td>
                <td>
                    <Input
                        type="text"
                        name="assetClass"
                        value={this.props.isFieldNull(this.state.editSecurity.assetClass)}
                        onChange={e => this.onChange(e, 'edit')}
                    />
                </td>
                <td>
                    <Input
                        type="text"
                        name="securityType"
                        value={this.props.isFieldNull(this.state.editSecurity.securityType)}
                        onChange={e => this.onChange(e, 'edit')}
                    />
                </td>
                <td>
                    <Input
                        type="text"
                        name="symbolTicker"
                        value={this.props.isFieldNull(this.state.editSecurity.symbolTicker)}
                        onChange={e => this.onChange(e, 'edit')}
                    />
                </td>
                <td>
                    <Input
                        type="text"
                        name="cusip"
                        value={this.props.isFieldNull(this.state.editSecurity.cusip)}
                        onChange={e => this.onChange(e, 'edit')}
                    />
                </td>
                <td>
                    <Input
                        type="textarea"
                        name="notes"
                        value={this.props.isFieldNull(this.state.editSecurity.notes)}
                        onChange={e => this.onChange(e, 'edit')}
                    />
                </td>
                <td>
                    <Input
                        className='m-0'
                        type="checkbox"
                        name="complete"
                        checked={this.props.isFieldNull(this.state.editSecurity.complete, true)}
                        onChange={e => this.onChange(e, 'edit')}
                    />
                </td>
                <td>
                    <Button className="mx-1" color="success" onClick={this.handleEdit} title="Edit Security">
                        <FontAwesomeIcon icon={faCheck} />
                    </Button>
                    <ConfirmButton className="mx-3" color="danger" onClick={() => this.onDelete(security.id)} title="Delete Security">
                        <FontAwesomeIcon icon={faTrashAlt} />
                    </ConfirmButton>
                    <Button className="mx-1" color="secondary" onClick={this.handleCancel} title="Cancel">
                        <FontAwesomeIcon icon={faTimes} />
                    </Button>
                </td>
            </tr>
        )
    }

    addRow = () => {
        this.props.info('ClientSecurities.js/addRow');
        return (
            <tr>
                <td>
                    <Input
                        type="text"
                        name="type"
                        placeholder="New Type"
                        value={this.props.isFieldNull(this.state.newSecurity.type)}
                        onChange={e => this.onChange(e)}
                    />
                </td>
                <td>
                    <Input
                        type="text"
                        name="symbol"
                        placeholder="Symbol"
                        value={this.props.isFieldNull(this.state.newSecurity.symbol)}
                        onChange={e => this.onChange(e)}
                    />
                </td>
                <td>
                    <Input
                        type="text"
                        name="assetClass"
                        placeholder='Asset Class'
                        value={this.props.isFieldNull(this.state.newSecurity.assetClass)}
                        onChange={e => this.onChange(e)}
                    />
                </td>
                <td>
                    <Input
                        type="text"
                        name="securityType"
                        placeholder='Security Type'
                        value={this.props.isFieldNull(this.state.newSecurity.securityType)}
                        onChange={e => this.onChange(e)}
                    />
                </td>
                <td>
                    <Input
                        type="text"
                        name="symbolTicker"
                        placeholder='Symbol Ticker'
                        value={this.props.isFieldNull(this.state.newSecurity.symbolTicker)}
                        onChange={e => this.onChange(e)}
                    />
                </td>
                <td>
                    <Input
                        type="text"
                        name="cusip"
                        placeholder='CUSIP'
                        value={this.props.isFieldNull(this.state.newSecurity.cusip)}
                        onChange={e => this.onChange(e)}
                    />
                </td>
                <td>
                    <Input
                        type="textarea"
                        name="notes"
                        placeholder='Notes'
                        value={this.props.isFieldNull(this.state.newSecurity.notes)}
                        onChange={e => this.onChange(e)}
                    />
                </td>
                <td>
                    <Input
                        className='m-0'
                        type="checkbox"
                        name="complete"
                        checked={this.props.isFieldNull(this.state.newSecurity.complete, true)}
                        onChange={e => this.onChange(e)}
                    />
                </td>
                <td>
                    <Button disabled={this.state.newSecurity.type === '' || this.state.newSecurity.type == null || this.state.newSecurity.symbol === '' || this.state.newSecurity.symbol == null} color="primary" onClick={this.handleAdd}>Add Security</Button>
                </td>
            </tr>
        )
    }

    render = () => {
        this.props.info('ClientSecurities.js/render');
        return (
            <Row>
                <Col md="12">
                    <table className="dataGrid">
                        <thead>
                            <tr>
                                <th className="py-2" colSpan={2}>Custodian Security Info</th>
                                <th className="py-2" colSpan={6}>Portfolio Management System Setup Security Info</th>
                            </tr>
                            <tr>
                                <th>Type</th>
                                <th>Symbol</th>
                                <th>Asset Class</th>
                                <th>Security Type</th>
                                <th>Symbol/Ticker</th>
                                <th>CUSIP</th>
                                <th>Notes</th>
                                <th>Complete</th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.props.report.securities.map((security) => (
                                <Fragment key={security.id}>{this.state.editSecurity.id === security.id ? this.editRow(security) : this.standardRow(security)}</Fragment>
                            ))}
                            {this.addRow()}
                        </tbody>
                    </table>
                </Col>
            </Row>
        )
    }
}

export default ClientSecurities;